/**
 * Slices one page out of a log step's response rows for rendering.
 *
 * @param {Object} params
 * @param {*} params.rows - The step response data; only arrays are paged.
 * @param {number} params.page - Zero-based page index; out-of-range pages clamp to the nearest page.
 * @param {number} params.pageSize - Rows per page (positive).
 * @returns {{ pageRows: *, totalPages: number, isLastPage: boolean }} - `pageRows` is the slice to
 *   render (or the untouched value when `rows` is not an array), `totalPages` is 0 for non-arrays,
 *   and `isLastPage` tells callers where content that follows the final row belongs.
 */
const getLogStepOutputPage = ({ rows, page, pageSize }) => {
  if (!Array.isArray(rows)) {
    return { pageRows: rows, totalPages: 0, isLastPage: true };
  }

  const totalPages = Math.ceil(rows.length / pageSize);
  const lastPage = Math.max(totalPages - 1, 0);
  const safePage = Math.min(Math.max(page, 0), lastPage);
  const startIndex = safePage * pageSize;

  return {
    pageRows: rows.slice(startIndex, startIndex + pageSize),
    totalPages,
    isLastPage: safePage === lastPage
  };
};

export default getLogStepOutputPage;
